module.exports = __webpack_public_path__ + "img/slide-button-rechts.8bcca67caa90d6d9ca5ced876f44536a.svg";